import * as React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Footer from "./components/Footer";
import Header from "./components/Header";
import Main from "./components/Main";

import './styles/App.css';

class App extends React.Component {
    public render() {
        return (
            <Router>
                <div className="App cover-container d-flex w-100 h-100 p-3 mx-auto flex-column">
                    <Header/>
                    <Main/>
                    <Footer/>
                </div>
            </Router>
        );
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.tsx